import React from 'react';

const feedbackEmail = process.env.REACT_APP_FEEDBACK_EMAIL;
const feedbackUrl = process.env.REACT_APP_FEEDBACK_URL;

const ErrorMessage = ({ message, title = 'Error' }) => {
  const hasFeedback = Boolean(feedbackEmail || feedbackUrl);

  return (
    <div className="card bg-red-50 border-red-200 p-6 my-6">
      <div className="flex items-start gap-3">
        <div className="text-2xl">⚠️</div>
        <div className="min-w-0">
          <h3 className="font-semibold text-red-900 mb-1">{title}</h3>
          <p className="text-red-700 text-sm">
            {message || 'Something went wrong. Please try again later.'}
          </p>
          {hasFeedback && (
            <p className="text-red-800 text-sm mt-3 flex flex-wrap items-center gap-x-3 gap-y-1">
              <span className="font-medium text-red-900">Feedback</span>
              {feedbackEmail && (
                <a
                  href={`mailto:${feedbackEmail}`}
                  className="underline hover:text-red-950"
                >
                  Email us
                </a>
              )}
              {feedbackUrl && (
                <a
                  href={feedbackUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-red-950"
                >
                  Report an issue
                </a>
              )}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
